export default __webpack_public_path__ + "static/media/001-Canadian flag.4277411b.svg";